import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button, StepGroup } from 'semantic-ui-react';
import * as yup from 'yup';
import moment from 'moment';
import Axios from 'axios';
import APP_CONSTANTS from '../../config/constants';


import AddTitleBar from '../../components/titleBar/addTitleBar';

import { DateData } from '../formikInput/date';
import { MyInput, MyTextArea } from '../../components/formikInput/input';


//Add-Product
import AddProduct from './addProduct';

//Dropdowns
import PurchaseOrderVendorDropdown from '../dropdowns/purchaseOrderVendorDropdown';
import PurchaseOrderBranchDropdown from '../dropdowns/purchaseOrderBranchDropdown';
import BranchDropdown from '../dropdowns/branchDropdown';
import VehicleDropdown from '../dropdowns/vendorVehicleDropdown';


//Actions 
import { updatePurchaseOrder, getPurchaseOrder } from '../../redux/actions/purchaseOrderActions';
import { useState } from 'react';
import TitleBar from '../titleBar/titleBar';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import { LOCAL_STORAGE } from '../../config/const';
import { FEATURES } from '../../config/features';

const EditPurchaseOrder = (props) => {

    const { updatePurchaseOrder, getPurchaseOrder, purchaseOrderDetails, purchaseOrderLoading } = props;
    //State
    const [branchData, setBranchData] = useState([]);
    const [vehicleData, setVehicleData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [vendorDetails, setVendorDetails] = useState({});
    const [gst, setGst] = useState('');
    const [vendorState, setVendorState] = useState('');
    const [vendorStateId, setVendorStateId] = useState('');
    const [masterState, setMasterState] = useState('');
    const [GSTExemptedReason, setGSTExemptedReason] = useState('');
  const [vendorPsLineGSTMappingData, setVendorPsLineGSTMappingData] = useState([])


    //UseEffect
    useEffect(() => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        const id = props.location.state.id
        const vendorId = props.location.state.vendorId

        getPurchaseOrder(id)


        Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setStateData(response.data.resultSet)
        }))
            .catch(error => console.log(error))

        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vendorMaster/vehicles/${vendorId}`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setVehicleData(response.data.resultSet)
        }))
            .catch(error => console.log(error))

        Axios.get(
            `${APP_CONSTANTS.BASE_URL}/masters/vendorPSLineItemGSTMapping?vendorId=${vendorId}&customerNo=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}`,
            {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: LOCAL_STORAGE.userToken,
            },
            }
        )
            .then((response) => {
            setVendorPsLineGSTMappingData(response.data.resultSet);
            })
            .catch((error) => console.log(error));

    }, [])

    useEffect(() => {
        if (purchaseOrderDetails?.[0]) {
            setVendorState(purchaseOrderDetails[0].vendorBranchStateName)
            setGst(purchaseOrderDetails[0].vendorBranchGst)
        }
    }, [stateData])


    //ArrayHelper
    Array.prototype.sum = function (prop) {
        var total = 0
        for (var i = 0, _len = this.length; i < _len; i++) {
            total += this[i][prop]
        }
        return total
    }

    //Get Data from Child Components
    const getBranchData = childData => {
        setBranchData(childData)
        setGst(purchaseOrderDetails[0]?.vendorBranchGst);

        const stateDetails = stateData.find(data => data.stateId === childData[0].vendorBranchStateId);
        if(stateDetails) {
            setVendorState(stateDetails?.state);
            setVendorStateId(stateDetails?.stateId)
        }
    };

    const getVehicleData = childData => {
        setVehicleData(childData)
    }

    const getVendorDetails = childData => {
        setVendorDetails(childData)

    }

    const getBranchSelected = (childData, vendorDetails) => {
        const branchDetails = vendorDetails.branches.find(data => data.vendorBranchCode === childData);
        const stateDetails = stateData.find(data => data.stateId === branchDetails.vendorBranchStateId);

        //Set GST and VendorState from Branch Selected
        setGst(branchDetails.vendorBranchGST);
        setVendorState(stateDetails.state);
        setVendorStateId(stateDetails.stateId)
    };

    const getMasterBranchSelected = (branchCode, branchData) => {
        const addedMasterBranchObject = branchData.find(data => data.branchCode === branchCode)
        setMasterState(addedMasterBranchObject.stateId)
        if (addedMasterBranchObject.gstChargeMechanism == "RCM") {
            setGSTExemptedReason('RCM')
        } else {
            setGSTExemptedReason('')
        }
    }

    if (purchaseOrderLoading) {

        return (
            <React.Fragment>
                <TitleBar title="Edit Purchase Order" LinkName="purchaseorder" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let poDetails = [];
        purchaseOrderDetails && purchaseOrderDetails[0].po_details.map((po, index) => {
            let temp = {}
            temp.productName = po.productId
            temp.productCode = po.psCode
            temp.startDate = po.startDate === "0000-00-00" ? "" : new Date(po.startDate)
            temp.endDate = po.endDate === "0000-00-00" ? "" : new Date(po.endDate)
            temp.quantity = po.productQty
            temp.rate = Number(po.productPrice)
            temp.discount = Number(po.discount)
            temp.discountType = po.discountType
            temp.iGstPercent = Number(po.igstPercent)
            temp.iGst = ''
            temp.cGstPercent = Number(po.cgstPercent)
            temp.cGst = ''
            temp.sGstPercent = Number(po.sgstPercent)
            temp.sGst = ''
            temp.amount = ''
            temp.remarks = po.remarks

            poDetails[index] = temp
        })


        //Formik
        const initialValues = {
            vendorId: purchaseOrderDetails ? purchaseOrderDetails[0].vendorId : '',
            vendorName: purchaseOrderDetails ? purchaseOrderDetails[0].vendorCode : '',
            vendorBranch: purchaseOrderDetails ? purchaseOrderDetails[0].vendorBranchCode : '',
            branch: purchaseOrderDetails ? purchaseOrderDetails[0].branchCode : '',
            gstNo: gst,
            vendorState: vendorState,
            isGstApplicable: true,
            chargeMechanismRCM: false,
            vehicleNo: purchaseOrderDetails?.[0]?.vehicleNo ? purchaseOrderDetails[0].vehicleNo : '',
            purchaseOrderDate: purchaseOrderDetails ? new Date(purchaseOrderDetails[0].poDate) : '',
            purchaseOrderNo: purchaseOrderDetails ? purchaseOrderDetails[0].poNumber : '',
            refNo: purchaseOrderDetails ? purchaseOrderDetails[0].poReferenceNo : '',
            productDetails: poDetails ? poDetails
                : [{
                    productName: '',
                    startDate: '',
                    endDate: '',
                    quantity: 1,
                    rate: '',
                    discount: '',
                    discountType: "1",
                    iGstPercent: '',
                    iGst: '',
                    cGstPercent: '',
                    cGst: '',
                    sGstPercent: '',
                    sGst: '',
                    amount: '',
                    remarks:''
                }],
            finalAmount: purchaseOrderDetails ? purchaseOrderDetails[0].totalOrderAmt : '',
            adjustmentAmount: purchaseOrderDetails ? purchaseOrderDetails[0].totalOrderAmt : '',
            remarks: purchaseOrderDetails ? purchaseOrderDetails[0].remarks : '',
        }

        const validateSchema = yup.object().shape({
            vendorName: yup.mixed().required('Partner Name is Required'),
            branch: yup.mixed().required('Branch is Required'),
            vendorBranch: yup.mixed().required("Partner Branch is Required"),
            purchaseOrderNo: yup.mixed().required('Purchase Order Number is Required'),
            refNo: yup.mixed().required('Reference Number is Required'),
            productDetails: yup.array().of(
                yup.object().shape({
                    productName: yup.string().required("Add a product/service"),
                    quantity: yup.number("Should be a number").required("Quantity is required").min(1, "Should be more than 0"),
                    rate: yup.number("Should be a number").required("Rate is required")
                        .when('productName', (productName, schema) => {
                            return FEATURES.isNegativeRateAllowedForPsLineItem(productName) ? schema : schema.min(1, "Should be more than 1") 
                        })
                    
                })
            )
        })

        const onSubmit = (values, onSubmitProps) => {
            const customerNumber = localStorage.getItem('customerNo');
            const userId = localStorage.getItem('userId');

            const psLineItems = [];
            values.productDetails.map((product, index) => {
                let temp = {}
                temp.psCode = product.productCode
                temp.psName = product.productName
                temp.startDate = product.startDate
                temp.endDate = product.endDate
                temp.psQty = product.quantity
                temp.psPrice = product.rate
                temp.psAmount = product.rate * product.quantity
                temp.igstPercent = product.iGstPercent
                temp.igstAmount = product.iGst
                temp.cgstPercent = product.cGstPercent
                temp.cgstAmount = product.cGst
                temp.sgstPercent = product.sGstPercent
                temp.sgstAmount = product.sGst
                temp.tdsTaxSectionId = product.tdsId
                temp.tdsTaxCode = product.tdsTaxCode
                temp.discount = product.discount
                temp.finalDiscount = product.discount
                temp.discountType = product.discountType
                temp.taxableAmount = product.rate * product.quantity
                temp.totalAmount = product.amount
                temp.remarks = product.remarks
                psLineItems[index] = temp
            });

            const updatePOData = {
                customerNo: customerNumber,
                userId: userId,
                poReferenceNo: purchaseOrderDetails[0].poReferenceNo,
                vendorCode: purchaseOrderDetails[0].vendorCode,
                branchCode: values.branch,
                vendorBranchCode: values.vendorBranch,
                vehicleNo: values.vehicleNo,
                poQuantity: psLineItems.length,
                poAmount: values.finalAmount,
                poNumber: values.purchaseOrderNo,
                sgstAmount: psLineItems.sum("sgstAmount"),
                cgstAmount: psLineItems.sum("cgstAmount"),
                igstAmount: psLineItems.sum("igstAmount"),
                adjustment: values.adjustmentAmount,
                remarks: values.remarks,
                gstTaxType: '',
                poDate: moment(values.purchaseOrderDate).format('DD-MM-YYYY'),
                tdsAmount: '',
                taxableAmount: psLineItems.sum("taxableAmount"),
                totalDiscount: psLineItems.sum("discount"),
                totalOrderAmt: values.finalAmount,
                psDetails: psLineItems,
            };

            updatePurchaseOrder(updatePOData).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });
        };

        return (
            <React.Fragment>
                <AddTitleBar title="Edit Purchase Order" LinkName="/purchaseorder" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}>
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => {

                            values.finalAmount = Number(values.productDetails.sum("amount")).toFixed(2)

                            return (
                                <>
                                    <Segment>
                                        <div className="ui form tiny">
                                            <FormUi.Group >
                                                <FormUi.Field width="2">
                                                    <label className="labelName mt-2">Partner Name</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="5">
                                                    <Fieldmik
                                                        component={PurchaseOrderVendorDropdown}
                                                        disabled name="vendorName"
                                                        value={values.vendorName}
                                                        placeholder="Partner Name"
                                                        getBranchData={getBranchData}
                                                        getVendorDetails={getVendorDetails}
                                                        getVehicleData={getVehicleData}
                                                        transporterMasterId={values.vendorId} />
                                                    {touched.vendorName && errors.vendorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorName}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                {values.vendorName ?
                                                    <>
                                                        <FormUi.Field width="3">
                                                            <label className="labelName mt-2">Partner Branch</label>
                                                        </FormUi.Field>
                                                        <FormUi.Field width="3">
                                                            <Fieldmik
                                                                component={PurchaseOrderBranchDropdown}
                                                                name="vendorBranch"
                                                                vendorId={values.vendorId}
                                                                vendorBranchCode={values.vendorBranch}
                                                                branchData={branchData}
                                                                getBranchSelected={getBranchSelected}
                                                                value={values.vendorBranch}
                                                                setVendorDetails={setVendorDetails}
                                                                setBranchData={setBranchData}
                                                            />
                                                            {touched.vendorBranch && errors.vendorBranch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorBranch}</strong> : ''}
                                                            {values.chargeMechanismRCM == true && <b style={{ color: "green" }}>GST Charge Mechanism - RCM</b>}
                                                        </FormUi.Field>
                                                    </>
                                                    :
                                                    ''
                                                }
                                            </FormUi.Group>
                                            <FormUi.Group >
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">GST</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    {/* <Fieldmik readOnly name="gstNo" placeholder="GST" value={gst} /> */}
                                                    {gst}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Partner State</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    {/* <Fieldmik readOnly name="vendorState" placeholder="Partner State" value={vendorState} /> */}
                                                    {vendorState}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                            <FormUi.Group >
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Vehicle Number</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik component={VehicleDropdown} name="vehicleNo" placeholder={values.vehicleNo} value={values.vehicleNo} vehicleData={vehicleData} />
                                                    {touched.vehicleNo && errors.vehicleNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vehicleNo}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Purchase Order Date</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="3">
                                                    <DateData
                                                        name={`purchaseOrderDate`}
                                                        autoComplete="off"
                                                        popperClassName="dateTime"
                                                        dateFormat="dd-MM-yyyy"
                                                        placeholderText="Start Date"
                                                        selected={values.purchaseOrderDate}
                                                        minDate={new Date()}
                                                        timeIntervals={5}
                                                        customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                    />
                                                    {touched.purchaseOrderDate && errors.purchaseOrderDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.purchaseOrderDate}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                            <FormUi.Group >
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Branch</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik component={BranchDropdown} name="branch" placeholder="Branch" value={values.branch} getMasterBranchSelected={getMasterBranchSelected} masterBranchCode={purchaseOrderDetails && purchaseOrderDetails[0].branchCode} />
                                                    {touched.branch && errors.branch ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.branch}</strong> : ''}
                                                    {
                                                        GSTExemptedReason ?
                                                            <b style={{ color: "green" }}>GST Charge Mechanism - {GSTExemptedReason}</b>
                                                            : null
                                                    }
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Remarks</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik component={MyTextArea} name="remarks" placeholder="remarks" />
                                                    {touched.remarks && errors.remarks ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.remarks}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                        </div>
                                    </Segment>
                                    <Segment>
                                        <div className="ui form  tiny">

                                            <FormUi.Group >
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Purchase Order Number</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik component={MyInput} name="purchaseOrderNo" placeholder="Purchase Order Number" />
                                                    {touched.purchaseOrderNo && errors.purchaseOrderNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.purchaseOrderNo}</strong> : ''}
                                                </FormUi.Field>
                                                <FormUi.Field width="1" />
                                                <FormUi.Field width="3">
                                                    <label className="labelName mt-2">Reference Number</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik component={MyInput} name="refNo" disabled />
                                                    {touched.refNo && errors.refNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.refNo}</strong> : ''}
                                                </FormUi.Field>
                                            </FormUi.Group>
                                            {/* FieldArray Component */}
                                            <AddProduct 
                                                isGstApplicable={values.chargeMechanismRCM ? !GSTExemptedReason ? true : false : true} 
                                                masterState={masterState} 
                                                vendorStateId={vendorStateId == '' ?  branchData.length > 0 && branchData[0].vendorBranchStateId : vendorStateId} 
                                                gstNotApplicableReason={values?.chargeMechanismRCM && GSTExemptedReason == 'RCM' ? 'GST charge mechanism is RCM for partner branch & branch' : !values?.charvendorgeMechanismRCM && GSTExemptedReason == 'RCM' ? 'GST not applicable for partner branch.' : purchaseOrderDetails && purchaseOrderDetails.length > 0 ? purchaseOrderDetails[0]?.gstNotApplicableReason : ''} 
                                                vendorPsLineGSTMappingData={vendorPsLineGSTMappingData}
                                                />

                                        </div>
                                    </Segment>
                                    <center><Button disabled={isSubmitting || purchaseOrderDetails?.[0] ? (purchaseOrderDetails[0].isModuleFlag || purchaseOrderDetails[0].isUsed) : false} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                                </>
                            )
                        }}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = state => ({
    purchaseOrderDetails: state.getPurchaseOrderData.purchaseOrder.data,
    purchaseOrderLoading: state.getPurchaseOrderData.isLoading
})

export default connect(mapStatetoProps, { updatePurchaseOrder, getPurchaseOrder })(EditPurchaseOrder)


